import { createFileRoute } from '@tanstack/react-router'
import { ListClinicPage } from '_/features/pets/ui/pages/list-clinic-page'

export const Route = createFileRoute('/_authenticated/pets/clinics/')({
	staticData: { title: 'clinics_title' },
	component: ListClinicPage,
})
